module.exports = __webpack_public_path__ + "static/media/img_ellipse_304.f2f90e47.webp";